/* ### Angular basic imports ### */
import {NgModule, ApplicationRef, APP_INITIALIZER} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';

/* ### Template & default imports ### */
import {SmartadminLayoutModule} from './shared/layout/layout.module';
import {routing} from './app.routing';
import {APP_RESOLVER_PROVIDERS} from './app.resolver';
import {AppState, InternalStateType} from './app.service';

/* ### Modules imports ### */
import {CoreModule} from './core/core.module';
import {CustomModule} from './+app-custom/custom.module';

/* ### Guards imports ### */
import {AuthGuard} from './+app-custom/guards/auth.guard';

/* ### Components imports ### */
import {AppComponent} from './app.component';

/* ### Services imports ### */
import {UserService} from './+app-custom/services/user.service';
import {IsbnService} from './+app-custom/services/isbn.service';
import {HistoryService} from './+app-custom/services/history.service';
import {AuthenticationService} from './+app-custom/services/authentication.service';
import {GeneralService} from './+app-custom/services/general.service';
import {AppRedirectService} from './+app-custom/services/app-redirect.service';

/* ### NG modules imports ### */
import {LoadingModule, ANIMATION_TYPES} from 'ngx-loading';
import {ReportService} from './+app-custom/services/report.service';
import {CookieService} from 'ngx-cookie-service';
import {TokenInterceptor} from './+app-custom/interceptors/token.interceptor';
import {RoleGuard} from './+app-custom/guards/role.guard';
import {appConfigurationProviderFactory, AppConfigurationProvider} from './+app-custom/providers/app-configuration.provider';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {AuthInterceptor} from './+app-custom/interceptors/auth.interceptor';
import {NoCacheHeadersInterceptor} from './+app-custom/interceptors/no-cache.interceptor';
import {AppThemeModule} from './+app-custom/theme/app-theme.module';

const APP_PROVIDERS = [
    ...APP_RESOLVER_PROVIDERS,
    AppState,
    {
        provide: 'Location',
        useValue: location
    },
    AppConfigurationProvider,
    {
        provide: APP_INITIALIZER,
        useFactory: appConfigurationProviderFactory,
        deps: [AppConfigurationProvider],
        multi: true
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: NoCacheHeadersInterceptor,
        multi: true
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthInterceptor,
        multi: true
    }
];

interface StoreType {
    state: InternalStateType,
    restoreInputValues: () => void,
    disposeOldHosts: () => void
}

@NgModule({
    bootstrap: [AppComponent],
    imports: [ // import Angular's modules
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        HttpModule,

        CoreModule,
        SmartadminLayoutModule,
        LoadingModule.forRoot({
            animationType: ANIMATION_TYPES.wanderingCubes,
            backdropBackgroundColour: 'rgba(0,0,0,0.1)',
            backdropBorderRadius: '4px',
            primaryColour: '#ffffff',
            secondaryColour: '#ffffff',
            tertiaryColour: '#ffffff'
        }),

        CustomModule,

        routing,

        AppThemeModule
    ],
    declarations: [
        AppComponent,
    ],
    exports: [],
    providers: [
        APP_PROVIDERS,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true
        },
        AuthGuard,
        AuthenticationService,
        UserService,
        CookieService,
        IsbnService,
        GeneralService,
        RoleGuard,
        ReportService,
        HistoryService,
        AppRedirectService
    ]
})
export class AppModule {
    constructor(public appRef: ApplicationRef, public appState: AppState) {
    }
}




// WEBPACK FOOTER //
// ./src/app/app.module.ts